require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./brand-design-behavioral-science-technologies.json") })
        }
      }, "path---brand-design-behavioral-science-technologies");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---brand-design-behavioral-science-technologies!./.cache/json/brand-design-behavioral-science-technologies.json
// module id = 367
// module chunks = 231608221292675